import {lazy, Suspense} from "react";
import classNames from 'classnames';

import Block from '../block'
import {backgroundColour} from "../../utils/block-utils";
import Action from "../../components/action";
import {getBlackColour, getLightGreyColour} from "../../utils/theme-utils";
import {Image} from "../../components/image";
import BillingProviderBadge from "./billing-provider-badge";

const SocialIcon = lazy(() =>
    import("react-social-icons").then((module) => ({default: module.SocialIcon}))
);


Design1.propTypes = {};

Design1.defaultProps = {};

const getIconColor = (showColour, value, baseColour) => {
    if (showColour) return;
    const textColour = getBlackColour(baseColour);
    const lightTextColour = getLightGreyColour(baseColour);
    switch (value) {
        case 'section-white':
            return textColour;
        case 'section-light':
            return textColour;
        case 'section-grey':
            return textColour;
        case 'section-black':
            return lightTextColour;
        case 'section-brand':
            return 'var(--primary-button-text-colour)';
        case 'section-dark':
            return lightTextColour;
        default:
            return ''
    }
}

export default function Design1(props) {
    const copyright = `Copyright © ${new Date().getFullYear()}`;
    const renderFooterItem = ({children, items, ...item}) => {
        const childItems = children?.length ? children : (items || []);
        const isLegacyWrappedLeaf = !item.action
            && childItems.length === 1
            && childItems[0]?.title === item.title
            && !(childItems[0]?.children?.length || childItems[0]?.items?.length);

        if (isLegacyWrappedLeaf) {
            return (
                <Action {...childItems[0]} button={false} showingActionButton={true}
                        style={{fontWeight: '501'}}/>
            );
        }

        if (!childItems.length) {
            return (
                <Action {...item} button={false} showingActionButton={true}
                        style={{fontWeight: '501'}}/>
            );
        }

        return (
            <div className={"flex flex-col"}>
                <div data-title="" style={{fontWeight: '501'}}>{item.title}</div>
                {item.action?.type === 'page' ? (
                    <Action {...item} button={false} showingActionButton={true}
                            className={"font-light"}/>
                ) : null}
                {childItems.map(({children, items, ...child}) => (
                    <Action key={child.uniqueUri} {...child} button={false}
                            showingActionButton={true} className="font-light"/>
                ))}
            </div>
        );
    };

    return (
        <Block id={props.id} actions={props.actions} hideInlineAddBlockButton={true} as={"footer"}
               className={classNames(props.className, backgroundColour(props.settings?.backgroundColour), "mt-auto")}>
            <div className={"mx-auto max-w-7xl py-6 px-4 space-y-4"} data-footer="">
                <div className={"grow w-full h-full max-w-[108px] sm:max-w-[144px]"}>
                    {props.settings?.logo ? (
                        <Image
                            alt={"Footer Logo"}
                            src={props.settings?.logo}
                            width={144}
                            className={"h-auto w-auto max-w-full max-h-10 sm:max-h-8"}
                        />
                    ) : (
                        <h2 data-title="" className={"fit-text"}>{props.title}</h2>
                    )}
                </div>
                <div className={"columns-1 sm:flex sm:flex-row"}>
                    {props.settings?.details &&
                        <div data-body="" dangerouslySetInnerHTML={{__html: props.settings?.details}}
                             className={"text-sm w-full rich-text mb-8 sm:mb-4 sm:pr-2 sm:w-2/5"}/>
                    }
                    <ul className={"text-sm sm:columns-2 space-y-2 w-full mb-8 sm:mb-4"}>
                        {props.items?.map((item) => (
                            <li key={item.uniqueUri}
                                className={"break-inside-avoid"}
                            >
                                {renderFooterItem(item)}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={"flex justify-between items-center pt-4 border-t"}>
                    <div className={"flex items-center min-w-fit"}>
                        <span className={"text-xs"}>{copyright}</span>
                    </div>
                    {(props.settings?.social && props.settings?.social.length > 0) ? (
                        <div className={"flex items-center justify-center flex-wrap gap-x-2 gap-y-2 px-4 sm:gap-x-3"}>
                            <Suspense fallback={<div className={"h-7 w-full"} />}>
                                {props.settings?.social?.map((item, i) => (
                                    <div key={i} className="break-inside-avoid">
                                        <SocialIcon className={"!w-7 !h-7"}
                                                    bgColor={getIconColor(!props.settings?.socialMonochromeColours, backgroundColour(props.settings?.backgroundColour), props.baseColour)}
                                                    target={"_blank"}
                                                    url={item?.action?.value?.toLowerCase()}/>
                                    </div>
                                ))}
                            </Suspense>
                        </div>
                    ) : null}
                    <div className={"flex items-center"}>
                        <BillingProviderBadge providerBrand={props.providerBrand} artworkOrigin={props.artworkOrigin}/>
                    </div>
                </div>
            </div>
        </Block>
    )
}
